import { CasteContext } from "./CasteContext";
import { useContext } from "react";

export const useCasteContext = () => {
    const context = useContext(CasteContext);
    if(!context){
        throw Error("useCasteContext should be used inside CasteContextProvidor");
    }
    return context;
}